import React from 'react'
import Bubble from '../Bubble/Bubble';
import "./containerx.css";
export default function Containerx({children}) {

  
    return (
        <div className="containerx">
            <Bubble></Bubble>
            {children}
        </div>
    )
}
